<template>
	<a id="product" class="inner-content-container">
	<div v-for = "product in productData" :key="product.id">
		<div class="center-text-container ">
			<div class="landing-red main-headline content-maintext light-text">
				{{product.headline}}
			</div>
		
			<div class="content-subtext light-text">
				{{product.descShort}}
			</div>

			<div class="light-text content-description subtext">
				{{product.DescLong}}
			</div>
		</div>

		<div class=" landing-valuation-grid p-grid p-justify-between">
			<div class="landing-valuation-cell light-text p-col-11 p-sm-12 p-md-5 p-lg-5 p-xl-2" v-for="col in products.productColumns" :key="col.id">
				{{col.text}}
			</div>
		</div>
		
		<img class="app-screenshot" :src="baseUrl + product.productImage.url"/>

		<div class="column-text-wrapper">
			<p id="md-text" v-html="productText[0]" class="markup-content content-description light-text" style="margin-top: -12em, display: inline-block"></p>
		</div>
	</div>

		<router-link to="/contact">
			<button class="flat-button-white content-description light-text" @click="linkTo()">
				{{products.buttonText}}
			</button>
		</router-link>
	
	</a>
</template>


<script>

	import JsonProvider from '../../../services/DataService.js';
	import {MarkdownProvider} from '../../../services/DataService.js';
	import {configData} from '../../../services/DataService.js';

	export default { 
		name: 'LandingProduct',
		data: 
			function(){ 
			return {
				products: {
					buttonText: "KONTAKT",
					productColumns: [{
						id: 1,
						text: "Wohn- und Gewerbeimmobilien",
					},
					{
						id: 2,
						text: "Bauträger- maßnahmen",
					},
					{
						id: 3,
						text: "Vereinfachte Wertermittlung nach § 24 BelWertV",
					},
					{
						id: 4,
						text: "Wertindikation",
					},],

				},
			productData: [],
			productText: [],
			}
		},

		methods: {
			linkTo() {
				this.$emit('contactEvent');
			}
		},

		created: async function() {
			this.baseUrl = configData.baseUrl.data.baseUrl;
			var jsonGetter = new JsonProvider();
			this.productData = await jsonGetter.fetchJsonObject('products', true);

			var mdp = new MarkdownProvider();
			this.productText[0] = mdp.convertMarkdown(this.productData[0].productText);

		
			setTimeout(function() {
			var elements = document.getElementsByClassName("markup-content");

			elements.forEach(el => {
				el.firstChild.style.marginTop ="0px";
			});
			},250);
		}
}
</script>

<style scoped>

	.inner-content-container {
		display: block;
	}

		#product-container {
		padding-bottom: 5em;
	}

	.main-headline {
		margin-bottom: 1em;
		text-align:center;
	}
	
	p.content-description > p{
		display: inline-block;
		color: red;
	}

	p {
		word-break: keep-all;
		text-align: left;
		margin: 0em !important;
		margin-top: 0;
		padding-top: 0;
	}

	.center-text-container {
		margin-bottom: 3em;
	}

	.landing-valuation-grid {
		margin: auto;
		margin-bottom: 5em;
		padding: 1em;
	}

	.landing-valuation-cell {
		font-size: 1.5em;	
		text-align: center;
		padding-bottom: 1em;
		padding-top: 1em;
		border-bottom: 2px solid #aa1c48;
	}

	.content-maintext {
		margin-bottom: 1em;
	}

	.column-text-wrapper {
		margin: auto;
		margin-bottom: 5em;
		max-width:65%;
		padding: 0.5em;
	}
	
	.light-text {
		margin-top: 0;
	}
	.subtext {
		margin-top: 1em;
	}
	
	strong {
		margin-top: -1em;
	}

	.app-screenshot {
		width:60%;
		height: auto;
		margin-bottom: 6em;
	}

	button {
		margin-bottom: 5em;
	}

	p-grid {
		gap: 1em;
	}

	@media (max-width: 2199px) {
		.landing-valuation-grid {
			margin-left: 8em;
			margin-right: 8em;
		}
	}

	@media (max-width: 991px) {
		.column-text-wrapper {
		}

		.landing-valuation-grid {
			margin-left: 8em;
			margin-right: 8em;
		}
		
	}

	@media (max-width: 767px) {
		.landing-valuation-cell {
			font-size: 1em;	
			width: 100%
		}

		.landing-valuation-grid {
		margin-left: 5em;
		margin-right: 5em;
		}
		
		.column-text-wrapper {
		margin: auto;
		margin-bottom: 3em;
		max-width:90%;
		padding: 0.5em;
		}

		.app-screenshot {
			margin-bottom: 4em;
		}
	}


</style>

